// extracted by mini-css-extract-plugin
export default {"spinLoading":"spinLoading--kpGgR","spinLoading__image":"spinLoading__image--hSwWG","animation-spin-loading-rotate":"animation-spin-loading-rotate--ykznH"};